import { Injectable } from '@angular/core';
import { SapError } from 'src/app/lego-utils';
import { NEVER } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MaterialWhereUsedDataService } from 'src/app/services/material-where-used-data.service';
import { CollectionState } from 'src/app/state/collection-state';
import { MaterialWhereUsed } from 'src/app/models/domain';

@Injectable({
  providedIn: 'root',
})
export class MaterialWhereUsedService {
  private readonly state = new CollectionState<MaterialWhereUsed>();

  public readonly materialWhereUsed$ = this.state.items$;
  public readonly loading$ = this.state.loading$;
  public readonly error$ = this.state.error$;

  public constructor(private readonly materialWhereUsedDataService: MaterialWhereUsedDataService) {}

  public loadByDesignId(designId: string) {
    this.state.setLoading(true);

    return this.materialWhereUsedDataService.getMaterialWhereUsedByDesignId(designId).pipe(
      tap((entities) => {
        this.state.set(entities);
      }),
      catchError((error: SapError) => {
        this.state.setError(error.message);

        return NEVER;
      }),
      map(() => undefined)
    );
  }
}
